import { render, staticRenderFns } from "./LivingDonorKidneySpecificDetails.vue?vue&type=template&id=72ad342c"
import script from "./LivingDonorKidneySpecificDetails.vue?vue&type=script&lang=ts"
export * from "./LivingDonorKidneySpecificDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports